module.exports = __webpack_public_path__ + "static/img/greenlogo.18594e05.png";